module.exports = __webpack_public_path__ + "img/keshi_littletitle_bg.2006919a.png";